module.exports = __webpack_public_path__ + "static/Abacus Budget Cockpit-b90cc3004b86ec97ba7a911ad2ba9efb.png";